import GroupType from '../../../../../js/enums/GroupType'

export const DEFAULT_FEED_NAME_KEY = 'icalendar.page.lightbox.name.default'
export const DEFAULT_LEAVE_TYPE_SELECTION = {
    showArchived: false,
    qualifier: window.LeaveTypeSelectionQualifier.ALL,
    leaveTypes: []
}
export const DEFAULT_USER_SELECTION = {
    all: true,
    userIds: [],
    groupIds: [],
    groupType: GroupType.USER_GROUP,
}

export const DEFAULT_SHARED_WITH_USER_SELECTION = {
    all: false,
    userIds: [],
    groupIds: [],
    groupType: GroupType.USER_GROUP,
}



// WEBPACK FOOTER //
// ./web/actiplans/js/icalendar/components/lightbox/constants.js